/* eslint-disable no-unused-vars */
// import React, { useContext, useEffect, useState } from 'react';
import React, { useContext, useEffect, useState, useMemo } from 'react';

import './tablecomponent.scss';
import { getWeeklyMaster, fetchAllReport } from "../../services/forecastService";
import { EditContext } from '../RightCompoent';
import { AuthContext } from "../../contexts/AuthContext";
import { HORIZON } from '../../utils/config';
import ForecastTrendChart from '../ForecastTrendChart';


import { displayProductLabel } from '../../utils/demoProductLabels.js';

export default function SOPTable({ selectedItemName, sopData, selectedType, isSingleModel }) {

  console.log("Rendering SOPTable with selectedItemName:", selectedItemName, "selectedType:", selectedType, "sopData:", sopData);

  const [loading, setLoading] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);

  const [error, setError] = useState(null);
  const [displayWeeks, setDisplayWeeks] = useState([]);
  const [prevMonths, setPrevMonths] = useState([]);
  const [sopReportData, setSopReportData] = useState([]);
  const { editingInputsValues, setEditingInputsValues } = useContext(EditContext);
  const { user } = useContext(AuthContext);
  const [displayMonthMap, setDisplayMonthMap] = useState({}); // display months/weeks in order
  const [currentWeekNo, setCurrentWeekNo] = useState(null);
  const [currentMonthStr, setCurrentMonthStr] = useState(null);


  const sopSelectedItem = useMemo(() => {

    if (!selectedItemName) return [];

    if (isSingleModel) {
      return [{ models: [selectedItemName] }];
    }

    return sopData?.[selectedItemName] || [];

  }, [selectedItemName, sopData, isSingleModel]);

  // First useffect for building columns
  useEffect(() => {
    async function fetchMaster() {
      try {
        const result = await getWeeklyMaster();

        const today = new Date();

        const formattedToday = today.toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
        })
          .replace(" ", "-")
          .replace(".", "");

        // find week for today
        const currentWeek = result.find((item) => item.dates === formattedToday);
        const uniqueWeeks = [...new Set(result.map((item) => item.wk_no))];
        const totalWeeks = uniqueWeeks.length;

        console.log("currentweeks, uniqueWeeks, totalWeeks: ", currentWeek, uniqueWeeks, totalWeeks)

        if (!currentWeek) {
          console.warn("No current week found for today’s date:", formattedToday);
          setPrevMonths([]);
          setDisplayMonthMap({});
          setDisplayWeeks([]);
        }
        else {
          // Build month -> week mapping once so we can show two previous-month totals
          // as single columns in the consensus table.
          const monthToWeeks = {};
          const monthsInOrder = [];
          const weekSeen = new Set();
          const weekInfo = {};

          result.forEach((row) => {
            const weekNo = Number(row.wk_no);
            const [day, month] = row.dates.split("-");

            if (!weekInfo[weekNo]) {
              weekInfo[weekNo] = {
                week_name: row.week_name,
                month,
                start: day,
                end: day
              };
            }
            if (row.last_day === 1) {
              weekInfo[weekNo].end = day;
            }

            if (weekSeen.has(weekNo)) return;
            weekSeen.add(weekNo);

            if (!monthToWeeks[month]) {
              monthToWeeks[month] = [];
              monthsInOrder.push(month);
            }
            monthToWeeks[month].push(weekNo);
          });

          console.log("Month to Weeks Mapping:", monthToWeeks, "months in order:", monthsInOrder);

          const weekNoToMonth = {};
          Object.entries(monthToWeeks).forEach(([month, weekNos]) => {
            weekNos.forEach((weekNo) => {
              weekNoToMonth[Number(weekNo)] = month;
            });
          });


          // Find the two months prior to the current month (wrap across year end).
          const currentMonth = currentWeek.dates.split("-")[1];
          const currentMonthIndex = monthsInOrder.indexOf(currentMonth);
          if (currentMonthIndex >= 0) {
            const prev1 = monthsInOrder[(currentMonthIndex - 1 + monthsInOrder.length) % monthsInOrder.length];
            const prev2 = monthsInOrder[(currentMonthIndex - 2 + monthsInOrder.length) % monthsInOrder.length];
            console.log("Current month:", currentMonth, " with index ", currentMonthIndex, "Previous months:", prev1, prev2);
            setPrevMonths([
              { label: prev2, weekNos: monthToWeeks[prev2] || [] },
              { label: prev1, weekNos: monthToWeeks[prev1] || [] },
            ]);
          } else {
            setPrevMonths([]);
          }

          // Build horizon weeks (future only)
          const horizonWeekNos = [];

          let currentIndex = uniqueWeeks.findIndex((wk) => Number(wk) === Number(currentWeek.wk_no));
          if (currentIndex > totalWeeks) {
            currentIndex = currentIndex - uniqueWeeks.length;
          }

          for (let i = 1; i <= HORIZON; i++) {
            // Wrap around using modulo
            const nextWeekNo = uniqueWeeks[(currentIndex + i) % totalWeeks];
            if (nextWeekNo != null) horizonWeekNos.push(Number(nextWeekNo));
          }

          // Current month must show all its weeks (past + current + future)
          const currentMonthWeeks = monthToWeeks[currentMonth] || [];

          // Build ordered display weeks: full current month, then horizon weeks (future months)
          const seen = new Set();
          const displayWeekNos = [];

          currentMonthWeeks.forEach((weekNo) => {
            const w = Number(weekNo);
            if (!seen.has(w)) {
              seen.add(w);
              displayWeekNos.push(w);
            }
          });

          console.log("display weeks after current month: ", displayWeekNos);

          horizonWeekNos.forEach((weekNo) => {
            const w = Number(weekNo);
            if (!seen.has(w)) {
              seen.add(w);
              displayWeekNos.push(w);
            }
          });
          console.log("display weeks after horizon: ", displayWeekNos);

          const displayWeeks = displayWeekNos.map((weekNo) => {
            const info = weekInfo[weekNo] || {};
            const month = info.month || weekNoToMonth[weekNo] || currentMonth;
            const weekName = info.week_name ? `${info.week_name} - ${month}` : `Wk ${weekNo} - ${month}`;
            const range = (info.start && info.end) ? `${info.start} – ${info.end}` : "";
            return {
              week_name: weekName,
              range,
              wk_no: Number(weekNo),
              predicted_wk_no: Number(weekNo),
              month
            };
          });

          console.log("display weeks after final:", displayWeeks);

          const displayMonthMap = {};
          displayWeekNos.forEach((weekNo) => {
            const month = weekInfo[weekNo]?.month || weekNoToMonth[weekNo] || currentMonth;
            if (!displayMonthMap[month]) displayMonthMap[month] = [];
            displayMonthMap[month].push(Number(weekNo));
          });

          console.log("display months map:", displayMonthMap);

          setDisplayMonthMap(displayMonthMap);
          setDisplayWeeks(displayWeeks);
          setCurrentWeekNo(Number(currentWeek.wk_no));
          setCurrentMonthStr(currentMonth);
        }
      } catch (err) {
        console.error("Error fetching week master data:", err);
      }
    }
    fetchMaster();
  }, []);

  // Second useEffect for fetching all reports for all models
  useEffect(() => {
    async function fetchReportsMaster() {
      try {
        setOverlayLoading(true);
        const allreports = await loadReports();
        console.log("Fetched all reports master data:", allreports);
        setSopReportData(allreports);
      } catch (err) {
        console.error("Error fetching week master data:", err);
      } finally {
        setOverlayLoading(false);
      }
    }
    fetchReportsMaster();
  }, []);


  // ✅ Fetch forcast reports for all models
  async function loadReports() {
    const report = await fetchAllReport();

    return report;
  }

  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", ".",
    ];

    if (
      !/[0-9]/.test(e.key) &&          // not a number
      !allowedKeys.includes(e.key)     // not in allowed special keys
    ) {
      e.preventDefault(); // block invalid input
    }

    // Prevent multiple decimals
    if (e.key === "." && e.target.value.includes(".")) {
      e.preventDefault();
    }
  };

  const handleInputChange = (wkIndx, updatedValue, model_type, uType) => {
    setSopReportData(prev => {
      const updated = structuredClone(prev || {});

      if (!updated[model_type]) updated[model_type] = {};
      if (!updated[model_type][selectedType]) updated[model_type][selectedType] = {};
      if (!updated[model_type][selectedType][uType]) updated[model_type][selectedType][uType] = {};

      updated[model_type][selectedType][uType][wkIndx] = updatedValue;
      return updated;
    });

    setEditingInputsValues(prev => [
      ...(prev || []),
      {
        type: selectedType,
        model_type,
        uType,
        week_no: wkIndx,
        value: updatedValue,
      }
    ]);
  };

  // Sum all weekly values that fall within a given month (used for prev-month columns).
  const getMonthTotal = (modelType, typeKey, metricKey, weekNos) => {
    if (!Array.isArray(weekNos) || weekNos.length === 0) return 0;
    return weekNos.reduce(
      (sum, weekNo) =>
        sum + (Number(sopReportData?.[modelType]?.[typeKey]?.[metricKey]?.[weekNo]) || 0),
      0
    );
  };

  const colorArr = ['blue', 'yellow', 'pink', 'green'];

  let counter = 0;

  //   const monthGroupedWeeks = useMemo(() => {
  //   return nextWeeks.reduce((acc, wk) => {
  //     const month = wk.week_name.split(" - ")[1]; // "Feb", "Mar", "Apr"
  //     if (!acc[month]) acc[month] = [];
  //     acc[month].push(wk);
  //     return acc;
  //   }, {});
  // }, [nextWeeks]);

  const monthGroupedWeeks = useMemo(() => {
    const grouped = {};
    Object.entries(displayMonthMap).forEach(([month, weekNos]) => {
      grouped[month] = weekNos;
    });
    return grouped;
  }, [displayMonthMap]);

  const displayWeekByNo = useMemo(() => {
    const map = {};
    displayWeeks.forEach((wk) => {
      map[wk.predicted_wk_no] = wk;
    });
    return map;
  }, [displayWeeks]);

  const displayWeekNos = useMemo(() => displayWeeks.map((wk) => wk.predicted_wk_no), [displayWeeks]);

  const consensusTrendChart = useMemo(() => {
    const modelCodes = sopSelectedItem.flatMap((group) => group?.models || []);
    if (!modelCodes.length || !displayWeekNos.length) return null;

    const sumForMetric = (metricKey, weekNo) =>
      modelCodes.reduce(
        (sum, modelCode) => sum + (Number(sopReportData?.[modelCode]?.[selectedType]?.[metricKey]?.[weekNo]) || 0),
        0
      );

    return {
      labels: displayWeekNos.map((wkNo) => `Wk ${wkNo}`),
      series: [
        {
          key: "formulated",
          label: "Statistical",
          color: "#002FA7",
          values: displayWeekNos.map((wkNo) => sumForMetric("formulated_forecast_val", wkNo)),
        },
        {
          key: "consensus",
          label: "Consensus",
          color: "#16A34A",
          values: displayWeekNos.map((wkNo) => sumForMetric("cons", wkNo)),
        },
        {
          key: "mlrf",
          label: "MLRF",
          color: "#9333EA",
          values: displayWeekNos.map((wkNo) => sumForMetric("mr_forecast_predicted_qty", wkNo)),
        },
        {
          key: "xgbf",
          label: "GBF",
          color: "#EA580C",
          values: displayWeekNos.map((wkNo) => sumForMetric("xgb_forecast_predicted_qty", wkNo)),
        },
      ],
    };
  }, [sopSelectedItem, displayWeekNos, sopReportData, selectedType]);

  const getWeekColClass = (weekNo) => {
    if (!currentWeekNo) return '';
    const wk = Number(weekNo);
    if (wk === currentWeekNo) return 'col-current-week';
    // Only highlight past-actual for weeks belonging to the current month
    if (currentMonthStr && displayMonthMap[currentMonthStr]?.includes(wk) && wk < currentWeekNo) return 'col-past-actual';
    return '';
  };

  return (
    <div className="tableUI max-h-full w-full table-container">
      {overlayLoading && (
        <div className="table-loader-overlay">
          <div className="loader-content">
            <div className="spinner"></div>
            <p>Loading forecast data...</p>
          </div>
        </div>
      )}
      {error && <p style={{ color: 'red' }}>Error: {error.message}</p>}

      {!loading && (
        <>
          <table className="table table-bordered table-hover table-striped custome-talbe _sand-op_table border-2">
            <thead className="fix [&>tr>th]:sticky [&>tr>th]:top-0 [&>tr>th]:bg-white [&>tr>th]:z-20">
              <tr>
                <th className="sticky-col sticky-model border-r-2 border-r-[#0000004f]">Model</th>
                <th className="sticky-col sticky-measure border-r-2 border-r-[#0000004f]">Measure</th>
                {/* Two single columns for previous months (month name only) */}
                {prevMonths.map((month) => (
                  <th key={`pm-${month.label}`} className="border-right">
                    {month.label}
                  </th>
                ))}
                {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                  <React.Fragment key={month}>

                    {weekNos.map((weekNo) => {
                      const weekMasterData = displayWeekByNo[weekNo] || {};

                      return (
                        <th key={weekNo} className={`border-right ${getWeekColClass(weekNo)}`}>
                          <div className="hCol">
                            <div>{weekMasterData.week_name || `Wk ${weekNo} - ${month}`}</div>
                            {weekMasterData.range ? (
                              <div className="font-extralight">{weekMasterData.range}</div>
                            ) : null}
                          </div>
                        </th>
                      );
                    })}

                    <th className="month-total-col bg-[]">
                      {month} Total
                    </th>

                  </React.Fragment>
                ))}


                <th className='grand-total-header'>Total</th>
              </tr>
            </thead>

            <tbody>
              {sopSelectedItem.length === 0 && <tr>
                <td colSpan={999}>
                  <div className="empty-state">
                    <h3>No Data Selected</h3>
                    <p>Select a Category or Model from the left panel to view forecast details.</p>
                  </div>
                </td>
              </tr>}
              {sopSelectedItem && sopSelectedItem.map((ele, index) => {

                return (
                  <React.Fragment key={index}>
                    {ele?.models && ele?.models.map((item, i) => {
                      counter++;
                      if (counter > 3) counter = 0;

                      return (
                        <React.Fragment key={i}>
                          <tr className={colorArr[counter]}>
                            <td rowSpan={6} className="border-rft sticky-col sticky-model">{displayProductLabel(item)}</td>
                          </tr>

                          <tr className={colorArr[counter]}>
                            <td className='border-r border-r-[#0000004f] sticky-col sticky-measure'>
                              {selectedType ? selectedType[0].toUpperCase() + selectedType.slice(1) : ""}
                            </td>

                            {/* Previous-month totals for this row */}
                            {prevMonths.map((month) => (
                              <td key={`pm-${month.label}-formulated l2m-month-cell`} className='border-r-2 border-r-[#0000004f] border-b border-b-[#d6d6d6]'>
                                {/* {getMonthTotal(item, selectedType, "formulated_forecast_val", month.weekNos).toFixed(0)} */}
                                {Number(sopReportData?.[item]?.[selectedType]?.formulated_forecast_val?.monthly_totals?.[month.label] ?? 0).toFixed(0)}
                              </td>
                            ))}


                            {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                              <React.Fragment key={month}>

                                {weekNos.map((weekNo) => (
                                  <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                    {Number(
                                      sopReportData?.[item]?.[selectedType]?.formulated_forecast_val?.[weekNo] ?? 0
                                    ).toFixed(0)}
                                  </td>
                                ))}

                                {/* Month Total Column */}
                                <td className="font-semibold month-total-cell border-b border-b-[#d6d6d6]">
                                  {Number(sopReportData?.[item]?.[selectedType]?.formulated_forecast_val?.projected_monthly_totals?.[month] ?? getMonthTotal(item, selectedType, "formulated_forecast_val", weekNos).toFixed(0))}
                                </td>


                              </React.Fragment>
                            ))}



                            <td className="font-semibold grand-total-cell">
                              {getMonthTotal(item, selectedType, "formulated_forecast_val", displayWeekNos).toFixed(0)}
                            </td>

                          </tr>

                          <tr className={colorArr[counter]}>
                            <td className='border-r border-r-[#0000004f] sticky-col sticky-measure'>Sales Op's</td>

                            {/* Previous-month totals for this row */}
                            {prevMonths.map((month) => (
                              <td key={`pm-${month.label}-so`} className='border-r-2 border-r-[#0000004f] border-b border-b-[#d6d6d6]'>
                                {getMonthTotal(item, selectedType, "so", month.weekNos).toFixed(0)}
                              </td>
                            ))}

                            {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                              <React.Fragment key={month}>
                                {weekNos.map((weekNo) => (
                                  user?.is_sop_admin === 1 ? (
                                    <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                      <input
                                        className='consensus_input'
                                        maxLength='6'
                                        style={{ textAlign: "right" }}
                                        type="text"
                                        value={
                                          Number(
                                            sopReportData?.[item]?.[selectedType]?.so?.[weekNo] ?? 0
                                          ).toFixed(0)
                                        }
                                        onKeyDown={handleKeyDown}
                                        onChange={(e) =>
                                          handleInputChange(
                                            weekNo,
                                            Number(e.target.value),
                                            item,
                                            "so"
                                          )
                                        }
                                        data-predicted_wk_no={weekNo}
                                      />
                                    </td>
                                  ) : (
                                    <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                      {Number(
                                        sopReportData?.[item]?.[selectedType]?.so?.[weekNo] ?? 0
                                      ).toFixed(0)}
                                    </td>
                                  )
                                ))}
                                <td className="font-semibold month-total-cell border-b border-b-[#d6d6d6]">
                                  {getMonthTotal(item, selectedType, "so", weekNos).toFixed(0)}
                                </td>
                              </React.Fragment>
                            ))}

                            <td className="font-semibold grand-total-cell ">
                              {getMonthTotal(item, selectedType, "so", displayWeekNos).toFixed(0)}
                            </td>

                          </tr>

                          <tr className={colorArr[counter]}>
                            <td className='border-r border-r-[#0000004f] sticky-col sticky-measure'>Consensus</td>

                            {/* Previous-month totals for this row */}
                            {prevMonths.map((month) => (
                              <td key={`pm-${month.label}-cons`} className='border-r-2 border-r-[#0000004f] border-b border-b-[#d6d6d6]'>
                                {getMonthTotal(item, selectedType, "cons", month.weekNos).toFixed(0)}
                              </td>
                            ))}

                            {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                              <React.Fragment key={month}>
                                {weekNos.map((weekNo) => (
                                  user?.is_consensus_admin === 1 ? (
                                    <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                      <input
                                        className='consensus_input'
                                        maxLength='6'
                                        style={{ textAlign: "right" }}
                                        type="text"
                                        value={
                                          Number(
                                            sopReportData?.[item]?.[selectedType]?.cons?.[weekNo] ?? 0
                                          ).toFixed(0)
                                        }
                                        onKeyDown={handleKeyDown}
                                        onChange={(e) =>
                                          handleInputChange(
                                            weekNo,
                                            Number(e.target.value),
                                            item,
                                            "cons"
                                          )
                                        }
                                      />
                                    </td>
                                  ) : (
                                    <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                      {Number(
                                        sopReportData?.[item]?.[selectedType]?.cons?.[weekNo] ?? 0
                                      ).toFixed(0)}
                                    </td>
                                  )
                                ))}
                                <td className="font-semibold month-total-cell border-b border-b-[#d6d6d6]">
                                  {getMonthTotal(item, selectedType, "cons", weekNos).toFixed(0)}
                                </td>
                              </React.Fragment>
                            ))}

                            <td className="font-semibold grand-total-cell">
                              {getMonthTotal(item, selectedType, "cons", displayWeekNos).toFixed(0)}
                            </td>

                          </tr>

                          <tr className={colorArr[counter]}>
                            <td title='Multiple Linear Regression Forecasting' className='border-r border-r-[#0000004f] sticky-col sticky-measure'>MLRF</td>

                            {/* Previous-month totals for this row */}
                            {prevMonths.map((month) => (
                              <td key={`pm-${month.label}-mlrf`} className='border-r-2 border-r-[#0000004f] border-b border-b-[#d6d6d6]'>
                                {getMonthTotal(item, selectedType, "mr_forecast_predicted_qty", month.weekNos).toFixed(0)}
                              </td>
                            ))}


                            {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                              <React.Fragment key={month}>

                                {weekNos.map((weekNo) => (
                                  <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                    {Number(
                                      sopReportData?.[item]?.[selectedType]?.mr_forecast_predicted_qty?.[weekNo] ?? 0
                                    ).toFixed(0)}
                                  </td>
                                ))}

                                {/* Month Total Column */}
                                <td className="font-semibold month-total-cell border-b border-b-[#d6d6d6]">
                                  {
                                    getMonthTotal(item, selectedType, "mr_forecast_predicted_qty", weekNos).toFixed(0)
                                  }
                                </td>


                              </React.Fragment>
                            ))}



                            <td className="font-semibold grand-total-cell">
                              {getMonthTotal(item, selectedType, "mr_forecast_predicted_qty", displayWeekNos).toFixed(0)}
                            </td>

                          </tr>

                          <tr className={`${colorArr[counter]} border-b-2 border-b-[#0000004f]`}>
                            <td title='XGBoost Regressor Forecasting' className='border-r border-r-[#0000004f] sticky-col sticky-measure'>GBF</td>

                            {/* Previous-month totals for this row */}
                            {prevMonths.map((month) => (
                              <td key={`pm-${month.label}-xgbf`} className='border-r-2 border-r-[#0000004f] border-b border-b-[#d6d6d6]'>
                                {getMonthTotal(item, selectedType, "xgb_forecast_predicted_qty", month.weekNos).toFixed(0)}
                              </td>
                            ))}


                            {Object.entries(monthGroupedWeeks).map(([month, weekNos]) => (
                              <React.Fragment key={month}>

                                {weekNos.map((weekNo) => (
                                  <td key={weekNo} className={`border-b border-b-[#d6d6d6] ${getWeekColClass(weekNo)}`}>
                                    {Number(
                                      sopReportData?.[item]?.[selectedType]?.xgb_forecast_predicted_qty?.[weekNo] ?? 0
                                    ).toFixed(0)}
                                  </td>
                                ))}

                                {/* Month Total Column */}
                                <td className="font-semibold month-total-cell border-b border-b-[#d6d6d6]">
                                  {
                                    getMonthTotal(item, selectedType, "xgb_forecast_predicted_qty", weekNos).toFixed(0)
                                  }
                                </td>


                              </React.Fragment>
                            ))}


                            <td className="font-semibold grand-total-cell">
                              {getMonthTotal(item, selectedType, "xgb_forecast_predicted_qty", displayWeekNos).toFixed(0)}
                            </td>

                          </tr>

                        </React.Fragment>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>

          {consensusTrendChart && (
            <ForecastTrendChart
              title="Consensus Vs Model Forecast Trend"
              subtitle={`${selectedType?.toUpperCase() || "TERTIARY"} view across selected models`}
              labels={consensusTrendChart.labels}
              series={consensusTrendChart.series}
            />
          )}
        </>
      )}
    </div>
  );
}
